import moment from "moment";

/*
 * @Author: jiangxd
 * @Date: 2021-08-23 11:18:32
 * @LastEditTime: 2021-08-23 13:18:41
 * @LastEditors: jiangxd
 * @Description:
 * @FilePath: /rs_ips_maintence/src/library/sheet/buffer.ts
 */
export const downloadFile = (data) => {
  const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" });
  const filename = moment(new Date()).format("YYYYMMDD_HHmmss") + ".xlsx";
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, filename);
  } else {
    const link = document.createElement("a");
    const body = document.querySelector("body");

    link.href = window.URL.createObjectURL(blob); // 创建对象url
    link.download = filename;

    // fix Firefox
    link.style.display = "none";
    body.appendChild(link);

    link.click();
    body.removeChild(link);

    window.URL.revokeObjectURL(link.href); // 通过调用 URL.createObjectURL() 创建的 URL 对象
  }
};
